import React, { useState, useEffect } from "react";
import StatCard from "../Components/statsCard";
import RecommendationSection from "../Components/RecommendationSection";
import { axiosInstance } from "../axios/index";
import { styled } from '@mui/material/styles';


const DashboardContainer = styled('div')(({ theme }) => ({
  padding: "16px",
  backgroundColor: "#f5f6fe",
  minHeight: "100vh",
  marginLeft: "40px",
  width: "calc(100% - 40px)",
  marginTop: "64px",

  '@media (max-width: 768px)': {
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%",
    padding: "12px"
  }
}));
const Dashboard = () => {
  const [counts, setCounts] = useState({
    totalUsers: 0,
    totalBosses: 0,
    totalRecommendations: 0,
  });

  const [pendingRecommendations, setPendingRecommendations] = useState([]);
  const [recentRecommendations, setRecentRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const Info = localStorage.getItem("info");
      const userId = JSON.parse(Info)?.userId;
      const [countsRes, pendingRes, recentRes] = await Promise.all([
        axiosInstance.get(`/boss/counts?userId=${userId}`),
        axiosInstance.get(`/recommendation/allPendingRecommendations?userId=${userId}`),
        axiosInstance.get(`/boss/allBosses?filter=recent&userId=${userId}`)
      ]);

      if (countsRes.data.success) {
        setCounts(countsRes.data.data);
      }


      if (pendingRes.data?.data?.length > 0) {
        const pendingData = pendingRes.data.data.slice(0, 5).map(rec => ({
          name: rec.bossName,
          company: rec.companyName,
          industry: rec.industry,
          id: rec._id,
        }));
        setPendingRecommendations(pendingData);
      }

      if (recentRes.data.success) {
        const recentData = recentRes.data.data.slice(0, 5).map(rec => ({
          name: rec.bossName,
          company: rec.companyName,
          industry: rec.industry,
          id: rec._id,
          status: "approved"
        }));
        setRecentRecommendations(recentData);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const stats = [
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M14.7651 14.8351C13.5345 14.8351 12.3315 14.4701 11.3082 13.7864C10.285 13.1027 9.48749 12.131 9.01654 10.994C8.5456 9.85703 8.42238 8.60595 8.66246 7.39895C8.90255 6.19196 9.49516 5.08327 10.3653 4.21307C11.2355 3.34288 12.3442 2.75027 13.5512 2.51019C14.7582 2.2701 16.0093 2.39332 17.1463 2.86427C18.2832 3.33521 19.255 4.13273 19.9387 5.15597C20.6224 6.17921 20.9873 7.38221 20.9873 8.61285C20.9873 10.2631 20.3318 11.8457 19.1649 13.0126C17.998 14.1795 16.4154 14.8351 14.7651 14.8351ZM14.7651 4.23952C13.8861 4.23952 13.0268 4.50018 12.2959 4.98854C11.565 5.4769 10.9954 6.17103 10.659 6.98315C10.3226 7.79526 10.2346 8.68889 10.4061 9.55103C10.5776 10.4132 11.0009 11.2051 11.6224 11.8267C12.244 12.4482 13.0359 12.8715 13.8981 13.043C14.7602 13.2145 15.6538 13.1265 16.4659 12.7901C17.2781 12.4537 17.9722 11.884 18.4605 11.1532C18.9489 10.4223 19.2096 9.56299 19.2096 8.68396C19.2096 8.10031 19.0946 7.52237 18.8713 6.98315C18.6479 6.44392 18.3205 5.95397 17.9078 5.54126C17.4951 5.12856 17.0052 4.80118 16.4659 4.57783C15.9267 4.35448 15.3488 4.23952 14.7651 4.23952ZM19.7162 15.9106C14.906 14.8276 9.87342 15.3489 5.38735 17.3951C4.77037 17.6898 4.2498 18.1537 3.88628 18.7328C3.52276 19.312 3.33124 19.9824 3.33401 20.6662V25.9551C3.33401 26.0718 3.35701 26.1874 3.40168 26.2952C3.44635 26.4031 3.51182 26.5011 3.59436 26.5836C3.6769 26.6662 3.7749 26.7316 3.88274 26.7763C3.99058 26.821 4.10617 26.844 4.2229 26.844C4.33963 26.844 4.45522 26.821 4.56307 26.7763C4.67091 26.7316 4.7689 26.6662 4.85144 26.5836C4.93398 26.5011 4.99946 26.4031 5.04413 26.2952C5.0888 26.1874 5.11179 26.0718 5.11179 25.9551V20.6662C5.10405 20.3201 5.1975 19.9794 5.38066 19.6857C5.56383 19.392 5.82874 19.1581 6.1429 19.0128C8.84527 17.7648 11.7885 17.1245 14.7651 17.1373C16.4329 17.1353 18.0951 17.3323 19.7162 17.724V15.9106ZM19.8407 24.364H25.2985V25.6084H19.8407V24.364Z" fill="#12188A" />
        <path d="M29.645 19.0862H25.0495V20.864H28.7561V28.304H16.1606V20.864H21.7606V21.2373C21.7606 21.473 21.8542 21.6991 22.0209 21.8658C22.1876 22.0325 22.4137 22.1262 22.6495 22.1262C22.8852 22.1262 23.1113 22.0325 23.278 21.8658C23.4447 21.6991 23.5384 21.473 23.5384 21.2373V17.7795C23.5384 17.5438 23.4447 17.3177 23.278 17.151C23.1113 16.9843 22.8852 16.8906 22.6495 16.8906C22.4137 16.8906 22.1876 16.9843 22.0209 17.151C21.8542 17.3177 21.7606 17.5438 21.7606 17.7795V19.0862H15.2717C15.036 19.0862 14.8099 19.1798 14.6432 19.3465C14.4765 19.5132 14.3828 19.7393 14.3828 19.9751V29.1928C14.3828 29.4286 14.4765 29.6547 14.6432 29.8214C14.8099 29.9881 15.036 30.0817 15.2717 30.0817H29.645C29.8808 30.0817 30.1069 29.9881 30.2736 29.8214C30.4403 29.6547 30.5339 29.4286 30.5339 29.1928V19.9751C30.5339 19.7393 30.4403 19.5132 30.2736 19.3465C30.1069 19.1798 29.8808 19.0862 29.645 19.0862Z" fill="#12188A" />
      </svg>,
      label: "Total Employees",
      value: counts.totalUsers
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M16.6602 4C12.8052 4 9.66016 7.145 9.66016 11C9.66016 13.379 10.8702 15.484 12.6912 16.75C8.58616 18.352 5.66016 22.352 5.66016 27H7.66016C7.66016 22.602 10.8512 18.926 15.0352 18.156L15.6602 20H17.6602L18.2852 18.156C22.4692 18.926 25.6602 22.602 25.6602 27H27.6602C27.6602 22.352 24.7342 18.352 20.6292 16.75C22.4492 15.484 23.6602 13.379 23.6602 11C23.6602 7.145 20.5152 4 16.6602 4ZM16.6602 6C19.4332 6 21.6602 8.227 21.6602 11C21.6602 13.773 19.4332 16 16.6602 16C13.8872 16 11.6602 13.773 11.6602 11C11.6602 8.227 13.8872 6 16.6602 6ZM15.6602 21L14.6602 27H18.6602L17.6602 21H15.6602Z" fill="#12188A" />
      </svg>,
      label: "Bosses Added",
      value: counts.totalBosses
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M18.4644 4.58906L20.8111 9.32106C21.1311 9.97973 21.9844 10.6117 22.7044 10.7317L26.9564 11.4451C29.6764 11.9024 30.3164 13.8917 28.3564 15.8544L25.0497 19.1877C24.4897 19.7517 24.1831 20.8411 24.3564 21.6211L25.3031 25.7477C26.0498 29.0144 24.3297 30.2771 21.4631 28.5704L17.4764 26.1904C16.7564 25.7611 15.5697 25.7611 14.8364 26.1904L10.8524 28.5704C7.99908 30.2771 6.26575 28.9997 7.01241 25.7477L7.95908 21.6211C8.13241 20.8411 7.82575 19.7517 7.26575 19.1877L3.95908 15.8544C2.01375 13.8904 2.64041 11.9024 5.35908 11.4451L9.61241 10.7317C10.3191 10.6117 11.1724 9.97973 11.4924 9.32106L13.8391 4.58906C15.1191 2.0224 17.1991 2.0224 18.4657 4.58906" stroke="#12188A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>,
      label: "Recommendations",
      value: counts.totalRecommendations
    },
  ];

  return (
    <DashboardContainer>
      <h1 style={{
        fontSize: "clamp(24px, 4vw, 32px)",
        fontWeight: "700",
        marginBottom: "24px",
        color: "#1a1a1a",
        fontFamily: "Urbanist",
      }}>
        Dashboard
      </h1>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "16px",
        marginBottom: "32px",
      }}>
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            icon={stat.icon}
            label={stat.label}
            value={stat.value}
          />
        ))}
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "24px"
      }}>
        <RecommendationSection
          title="Pending Recommendations"
          data={pendingRecommendations}
          loading={loading}
        />
        <RecommendationSection
          title="Recent Bosses"
          data={recentRecommendations}
          loading={loading}
          viewType="recent"
        />
      </div>
    </DashboardContainer >
  );
};

export default Dashboard;